<template>
<div class="new-label-form">
    <table>
        <pt-form-list-item label="标签名称" required>
            <wt-input :class="$style['label-name']" v-model="form.name"  data-vv-as="标签名称"
            name="type"  v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="标签类型" required>
            <wt-selector :options="labelTypes"  :class="$style['label-name']" v-model="form.type" data-vv-as="标签类型"
            name="type"  v-validate="'required'"></wt-selector>
        </pt-form-list-item>
    </table>
    <div class="button-div">
        <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import { selectLabelTypes } from './label-option'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    labelDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelTypes: selectLabelTypes,
      form: this.labelDetail,
      loading: false
    }
  },
  watch: {
    labelDetail: {
      handler: function (val) {
        this.form = val
        this.form.type = val.type || '商品标签'
      },
      immediate: true
    }
  },
  methods: {
    submit () {
      this.validate('form').then(formValue => {
        this.loading = true
        let apiUrl = this.isEdit ? 'editLabel' : 'createLabels'
        let textTip = (this.isEdit ? '编辑' : '新建')
        this.$store.dispatch(apiUrl, formValue).then(res => {
          this.loading = false
          this.$message.success(textTip + '标签成功')
          this.$emit('close', true)
        }).catch(err => {
          this.loading = false
          this.$message.error(err || textTip + '标签失败')
        })
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>
<style module lang="less">
.label-name{
    width: 300px
}

</style>
<style lang="less">
.new-label-form{
    .button-div{
        padding:0
    }
}
</style>
